import React from "react";
import { Link } from "react-router-dom";
import { replace20 } from "../../utils/functions";
import breadCrumbArrow from "../../assets/images/svg/breadCrumbArrow.svg";
import { observer } from "mobx-react";
import PerformanceStore from "../../store/PerformanceStore";

const BreadCrumb = ({
  locationArr,
  // clickFunction,
  parentName,
  from,
  location,
}) => {
  // const navigate = useNavigate();
  // const handleClick = (index, data) => {
  //   clickFunction(index, data);
  // };

  return (
    <div className="portfolio_breadcrumbs_div">
      <div className="portfolio_breadcr">
        {locationArr?.length > 1 ? (
          <nav className="portfolio_breadcrumb">
            <ul>
              {locationArr?.map((data, index) => (
                <li
                  key={index}
                  id={`${parentName}_${index}`}
                  // onClick={() => handleClick(index, data)}
                >
                  {index < locationArr.length - 1 && (
                    <Link
                      to={data.path}
                      state={{
                        ...data.state,
                      }}
                      // onClick={() => {
                      //   navigate(`${data.path}`, { state: { ...data.state } });
                      // }}
                      id="breadlink1"
                      className={`bread-crumb-link ${
                        index + 1 === locationArr.length
                          ? "lightlink"
                          : "breadlink"
                      }`}
                      //  to={data.path}
                    >
                      {index !== 0 && (
                        <img
                          style={{
                            marginRight: "5.5px",
                            marginLeft: "6px",
                          }}
                          className="bread_a"
                          src={breadCrumbArrow}
                          alt="arr"
                        />
                      )}
                      <span>
                        {parentName !== "performance"
                          ? replace20(data.show)
                          : index !== 1
                          ? replace20(
                              PerformanceStore.selectedAssetClass.name +
                                " Performance"
                            )
                          : replace20(data.show)}
                      </span>
                    </Link>
                  )}
                  {index === locationArr.length - 1 && (
                    <div className="lightlink blueTextColor" aria-hidden={true}>
                      <img
                        style={{
                          marginRight: "5.5px",
                          marginLeft: "6px",
                        }}
                        className="bread_a"
                        src={breadCrumbArrow}
                        alt="arr"
                      />
                      <span>{replace20(data.show)}</span>
                    </div>
                  )}
                </li>
              ))}
            </ul>
          </nav>
        ) : (
          ""
        )}
      </div>
    </div>
  );
};

export default observer(BreadCrumb);
